<div class="u-flex-full">
  <label>{{value?.fullName}}</label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearUser()">
    <mat-icon>close</mat-icon>
  </button>
</div>
